/**
 * Back to Top Component
 *
 * @package Commcore26
 */

export const BackToTop = {
	/**
	 * Initialize back to top button
	 */
	init() {
		this.button = document.querySelector('.back-to-top');

		if (!this.button) {
			this.createButton();
		}

		this.threshold = 300;
		this.bindEvents();
		this.checkScroll();
	},

	/**
	 * Create the back to top button if it doesn't exist
	 */
	createButton() {
		this.button = document.createElement('button');
		this.button.className = 'back-to-top';
		this.button.setAttribute('aria-label', 'Back to top');
		this.button.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<polyline points="18 15 12 9 6 15"></polyline>
			</svg>
		`;
		document.body.appendChild(this.button);
	},

	/**
	 * Bind event listeners
	 */
	bindEvents() {
		// Check scroll position
		window.addEventListener(
			'scroll',
			window.commcore26.throttle(() => this.checkScroll(), 100)
		);

		// Scroll to top on click
		this.button.addEventListener('click', () => this.scrollToTop());
	},

	/**
	 * Check scroll position and show/hide button
	 */
	checkScroll() {
		const scrollY = window.scrollY || window.pageYOffset;

		if (scrollY > this.threshold) {
			this.show();
		} else {
			this.hide();
		}
	},

	/**
	 * Show button
	 */
	show() {
		this.button.classList.add('is-visible');
	},

	/**
	 * Hide button
	 */
	hide() {
		this.button.classList.remove('is-visible');
	},

	/**
	 * Scroll to top of page
	 */
	scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	},
};
